import { render } from "./PhoneForm.vue?vue&type=template&id=bbdbfd78&scoped=true"
import script from "./PhoneForm.vue?vue&type=script&lang=js"
export * from "./PhoneForm.vue?vue&type=script&lang=js"

import "./PhoneForm.vue?vue&type=style&index=0&id=bbdbfd78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdbfd78"]])

export default __exports__